module.exports = __webpack_public_path__ + "img/logo.b4c4a306.png";